import React from 'react';

const PrIcon = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='currentColor'>
    <path d='M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-8a5 5 0 1 1 0 10A5 5 0 0 1 18 13zM6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 2a5 5 0 1 1 0-10A5 5 0 0 1 6 10zm8.5 4.5h-1A5.5 5.5 0 0 0 8 20v1H6v-1a7.5 7.5 0 0 1 7.5-7.5h1v2z' />
  </svg>
);

export default PrIcon;
